import React from 'react';

import useAdditionalGroupsCart from 'modules/cart/util/use-additional-groups-cart';
import {AdditionalPriceWhenFree} from 'modules/products/types';
import Column from 'shared/components/column';
import Row from 'shared/components/row';
import {MediumText, RegularText} from 'shared/components/text';
import styled from 'styled-components';
import {AdditionalProps} from 'modules/additionals/types';
import toBrl from 'shared/util/to-brl';

interface Props extends AdditionalProps {
  isFree: boolean;
  additionalGroupConfigId: string;
  productId: string;
  additionalPricesWhenFree: AdditionalPriceWhenFree[];
}

const SingleAdditional: React.FC<Props> = ({
  id,
  name,
  description,
  additionalGroupConfigId,
  productId,
  isFree,
  additionalPricesWhenFree,
  ...props
}) => {
  const {getAdditionalGroupCart, toggleAdditional, removeAdditional} =
    useAdditionalGroupsCart(productId);
  const additionalsDraft = getAdditionalGroupCart(additionalGroupConfigId);
  const active = !!additionalsDraft?.find((additional) => additional.id === id);

  const handleAdditional = () =>
    (active ? removeAdditional : toggleAdditional)(additionalGroupConfigId, id);

  const chargeWhenFreePrice = additionalPricesWhenFree?.find(
    (additional) => additional.id === id,
  )?.price;

  const price = !isFree ? props.price : chargeWhenFreePrice;

  return (
    <Container onClick={handleAdditional}>
      <Row justifyContent="space-between">
        <Column>
          <MediumText size="small">{name}</MediumText>
          {description && <RegularText size="small">{description}</RegularText>}
          {price ? (
            <RegularText style={{marginTop: 5}} size="small">
              + {toBrl(price)}
            </RegularText>
          ) : null}
        </Column>
        <Radius {...{active}} onClick={handleAdditional} />
      </Row>
    </Container>
  );
};

export default SingleAdditional;

interface RadiusProps {
  active?: boolean;
}

const Container = styled.button`
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.4);
  background-color: white;

  border: none;
  cursor: pointer;
`;

const Radius = styled.button<RadiusProps>`
  width: 25px;
  height: 25px;
  border-radius: 13px;
  background-color: ${(props) => (props.active ? 'white' : '#ebebeb')};
  border: ${(props) =>
    props.active ? `6px solid ${props.theme.colors.primary}` : '0'};

  cursor: pointer;
  padding: 0;
`;
